// Portfolio da Áxis Saúde Digital — produtos nomeados + soluções especializadas no ecossistema Tasy

export const FLAGSHIP_PRODUCTS = [
  {
    id: "synir",
    name: "SYNIR",
    tagline: "Motor de auditoria e faturamento do Pronto Atendimento",
    problem:
      "Conta parada é receita parada: o faturamento caça erro e fecha conta por conta, enquanto pendências se perdem entre os setores.",
    value:
      "Lê a guia e os anexos, confere evoluções, laudos, autorizações e materiais, abre pendências para o setor certo e, quando a conta está pronta, fecha e protocola sozinho no mês certo — integrado ao TASY.",
    features: [
      "455 contas auditadas em um único dia",
      "Correções seguras antes de fechar, tudo em log",
      "Pendências direcionadas por setor",
      "Pendência fecha sozinha no TASY quando resolvida",
      "Diagnóstico de recusa: de 25 códigos para 1 crítica",
      "Regras por convênio",
      "Protocolo no mês certo pela data de corte",
      "Relatórios conta a conta",
    ],
    icon: "ScanSearch",
    isNew: true,
  },
  {
    id: "wely",
    name: "Wely",
    tagline: "Plataforma de Business Intelligence Hospitalar",
    problem:
      "Diretoria e gestores sem visibilidade em tempo real dos indicadores críticos da operação hospitalar.",
    value:
      "Dashboards corporativos que consomem dados diretamente do Tasy e apresentam KPIs assistenciais e financeiros em painéis intuitivos.",
    features: [
      "Ocupação hospitalar em tempo real",
      "Produção médica e TMP",
      "Faturamento e convênios",
      "Centro cirúrgico e P.A.",
      "Internações e custos assistenciais",
      "Indicadores financeiros consolidados",
      "Painéis por perfil (diretoria / assistência)",
      "Dados extraídos direto do Tasy",
    ],
    icon: "BarChart3",
  },
  {
    id: "huggin",
    name: "HUGGIN",
    tagline: "Plataforma Inteligente de Auditoria Hospitalar",
    problem:
      "Auditorias dispersas em múltiplos sistemas, com conferência manual demorada e inconsistências difíceis de rastrear.",
    value:
      "Centraliza informações clínicas, administrativas e financeiras em um único ambiente — acelerando a conferência de contas e a detecção de inconsistências.",
    features: [
      "Auditoria concorrente e retrospectiva",
      "Painéis gerenciais em tempo real",
      "Consulta integrada ao ERP Tasy",
      "Indicadores assistenciais e financeiros",
      "Relatórios personalizados",
      "Rastreabilidade das análises",
      "Dashboards interativos",
      "Redução do tempo de auditoria",
    ],
    icon: "ClipboardCheck",
  },
  {
    id: "muninn",
    name: "MUNINN",
    tagline: "Inteligência Artificial para Análise de Glosas",
    problem:
      "Arquivos XML de glosas em volume massivo, padrões ocultos e trabalho manual intenso das equipes de faturamento.",
    value:
      "Interpreta milhares de registros em segundos, classifica motivos, aponta recorrências e apoia a recuperação de receita.",
    features: [
      "Importação automática de XML TISS",
      "Leitura inteligente de arquivos",
      "Identificação de motivos de glosa",
      "Classificação por convênio",
      "Dashboards analíticos",
      "Estatísticas de recorrência",
      "Apoio à recuperação de receita",
      "Exportação de relatórios",
    ],
    icon: "BrainCircuit",
  },
  {
    id: "eirai",
    name: "EIRAI",
    tagline: "Assistente Clínico com Inteligência Artificial",
    problem:
      "Profissionais de saúde precisam interpretar exames e tomar decisões clínicas com agilidade — em meio a alto volume de informação.",
    value:
      "Aplicativo assistente médico com IA que lê e identifica exames, apoia diagnósticos e oferece suporte clínico em tempo real na palma da mão.",
    features: [
      "Leitura e interpretação de exames",
      "Identificação automatizada de padrões",
      "Suporte à decisão clínica",
      "Sugestões baseadas em evidência",
      "Consulta rápida de referências",
      "Aplicativo mobile (iOS · Android)",
      "IA treinada em contexto hospitalar",
      "Privacidade e LGPD por padrão",
    ],
    icon: "Bot",
  },
  {
    id: "escalamed",
    name: "EscalaMed",
    tagline: "Sistema Inteligente de Escalas Médicas",
    problem:
      "Escalas médicas e multiprofissionais em planilhas — cobertura de plantões e visão em tempo real virando dor de cabeça.",
    value:
      "Planejamento, controle de plantões, cobertura automática e visualização em tempo real, com relatórios de produtividade.",
    features: [
      "Escalas mensais",
      "Controle de plantões",
      "Cobertura automática",
      "Gestão de equipes",
      "Calendário inteligente",
      "Notificações",
      "Relatórios de produtividade",
    ],
    icon: "CalendarClock",
  },
  {
    id: "autorizacoes",
    name: "Autorizações Inteligentes",
    tagline: "Automação de solicitações junto às operadoras",
    problem:
      "Equipes gastam horas navegando manualmente nos portais das operadoras para consultar guias e obter autorizações.",
    value:
      "Acesso automatizado aos portais, captura de protocolos, acompanhamento de status e integração direta ao Tasy.",
    features: [
      "Login automático nos portais",
      "Consulta de guias",
      "Solicitação de autorizações",
      "Captura de protocolos",
      "Acompanhamento do status",
      "Histórico das solicitações",
      "Integração com o ERP Tasy",
    ],
    icon: "ShieldCheck",
  },
  {
    id: "assinatura",
    name: "Assinatura Digital",
    tagline: "Documentos hospitalares assinados em tablets",
    problem:
      "Volume alto de documentos em papel com custo, risco jurídico e baixa rastreabilidade nos processos assistenciais.",
    value:
      "Assinatura eletrônica direta em tablets, integrada ao Tasy, com validade jurídica ICP-Brasil e trilha completa de auditoria.",
    features: [
      "Assinatura eletrônica em tablets Android",
      "Integração automática com o Tasy",
      "Armazenamento seguro e criptografado",
      "Rastreabilidade completa",
      "Auditoria e trilha jurídica",
      "Redução de papel e custo operacional",
      "Suporte a múltiplos signatários",
    ],
    icon: "FileSignature",
  },
  {
    id: "anexos",
    name: "Anexos & Documentos",
    tagline: "Gestão inteligente de documentos para faturamento",
    problem:
      "Equipes de faturamento perdem horas procurando anexos e documentos dispersos entre pastas e sistemas.",
    value:
      "Extensão integrada ao Tasy que organiza, indexa e localiza anexos por paciente e atendimento em segundos.",
    features: [
      "Consulta rápida por paciente",
      "Organização automática",
      "Pesquisa por atendimento",
      "Visualização integrada ao Tasy",
      "Histórico documental completo",
      "Filtros inteligentes",
      "Redução de tempo de busca",
    ],
    icon: "FolderSearch",
  },
];

export const CORE_SOLUTIONS = [
  {
    id: "parametrizacao",
    name: "Parametrização Avançada do Tasy",
    problem:
      "Processos operacionais que não aproveitam todo o potencial do Tasy — regras mal configuradas e cadastros inconsistentes.",
    value:
      "Especialistas ajustam regras de negócio, cadastros, integrações e fluxos para maximizar desempenho do ERP.",
    highlights: [
      "Módulos e regras financeiras",
      "Regras assistenciais",
      "Cadastros e convênios",
      "Faturamento e contabilidade",
      "Prescrição e atendimento",
      "Segurança de acesso",
    ],
    icon: "Settings2",
  },
  {
    id: "relatorios",
    name: "Relatórios Personalizados",
    problem:
      "Necessidade de relatórios sob medida que a versão padrão do Tasy não entrega.",
    value:
      "Desenvolvimento de relatórios gerenciais, operacionais e estratégicos totalmente personalizados.",
    highlights: [
      "Assistenciais e financeiros",
      "Indicadores operacionais",
      "Controle de produtividade",
      "Auditoria e faturamento",
      "Estatísticas hospitalares",
    ],
    icon: "FileText",
  },
  {
    id: "automacao",
    name: "Automação de Processos Hospitalares",
    problem:
      "Rotinas manuais e repetitivas consomem centenas de horas mensais das equipes.",
    value:
      "Robôs e automações eliminam tarefas repetitivas, consolidam dados e notificam equipes automaticamente.",
    highlights: [
      "Geração automática de documentos",
      "Processamento de arquivos",
      "Atualização de informações",
      "Integração entre sistemas",
      "Consolidação de dados",
      "Notificações automáticas",
    ],
    icon: "Workflow",
  },
  {
    id: "sistemas-web",
    name: "Desenvolvimento de Sistemas Web",
    problem:
      "Demandas específicas do hospital que sistemas de mercado não atendem.",
    value:
      "Sistemas web sob medida com foco em segurança, performance, integração e usabilidade.",
    highlights: [
      "PHP · Python · JavaScript",
      "HTML5 · CSS3",
      "Oracle · MySQL",
      "APIs REST · Docker",
      "Linux · Windows Server",
    ],
    icon: "Code2",
  },
  {
    id: "consultoria",
    name: "Consultoria Especializada em ERP Tasy",
    problem:
      "Projetos de implantação ou otimização do Tasy sem parceiro com domínio real do ecossistema.",
    value:
      "Diagnóstico, revisão de processos, parametrizações, integrações, treinamentos e desenvolvimento sob medida.",
    highlights: [
      "Diagnóstico operacional",
      "Revisão de processos",
      "Parametrização e implantação",
      "Integrações",
      "Otimização de desempenho",
      "Capacitação de usuários",
    ],
    icon: "Compass",
  },
];
